module.exports = __webpack_public_path__ + "media/images/supporters_lp/fork11-f5bb72b41f33a55a14c683042eec24f9.png";